{
  "toasts": {
    "created": "Webhook criado com sucesso!",
    "createError": "Erro ao criar webhook",
    "updated": "Webhook atualizado com sucesso!",
    "updateError": "Erro ao atualizar webhook",
    "deleted": "Webhook excluído com sucesso!",
    "deleteError": "Erro ao excluir webhook",
    "testSent": "Webhook de teste enviado!",
    "testError": "Erro ao enviar webhook de teste"
  },
  "webhooks": {
    "events": {
      "userCreated": "Membro Criado",
      "userUpdated": "Membro Alterado",
      "enrollmentCreated": "Matrícula Criada",
      "enrollmentRemoved": "Matrícula Removida",
      "lessonCompleted": "Aula Concluída",
      "courseCompleted": "Curso Concluído",
      "paymentApproved": "Pagamento Aprovado",
      "paymentRefunded": "Pagamento Reembolsado"
    },
    "validation": {
      "nameRequired": "Informe o nome do webhook",
      "urlRequired": "Informe a URL do webhook",
      "eventsRequired": "Selecione ao menos um evento"
    },
    "secretCopied": "Secret copiado para a área de transferência",
    "subtitle": "Gerencie webhooks para integrar com sistemas externos",
    "new": "Novo Webhook",
    "active": "Ativo",
    "inactive": "Inativo",
    "eventCount_one": "{{count}} evento",
    "eventCount_zero": "{{count}} eventos",
    "eventCount_other": "{{count}} eventos",
    "actions": {
      "viewLogs": "Ver logs",
      "sendTest": "Enviar teste",
      "copySecret": "Copiar secret",
      "edit": "Editar",
      "delete": "Excluir",
      "cancel": "Cancelar",
      "save": "Salvar",
      "create": "Criar"
    },
    "empty": {
      "title": "Nenhum webhook cadastrado",
      "description": "Crie seu primeiro webhook para integrar com sistemas externos"
    },
    "form": {
      "editTitle": "Editar Webhook",
      "editDescription": "Atualize as configurações do webhook.",
      "createDescription": "Configure um novo webhook para receber notificações de eventos.",
      "name": "Nome",
      "namePlaceholder": "Ex: Notificação Zapier",
      "urlPlaceholder": "https://exemplo.com/webhook",
      "events": "Eventos",
      "activeHint": "Quando desativado, nenhuma entrega será realizada"
    },
    "delete": {
      "title": "Excluir webhook",
      "description": "Tem certeza que deseja excluir o webhook <bold>{{name}}</bold>? Esta ação não pode ser desfeita e todos os logs de entrega serão removidos."
    },
    "logs": {
      "title": "Logs - {{name}}",
      "description": "Entregas recentes deste webhook",
      "event": "Evento",
      "status": "Status",
      "code": "Código",
      "date": "Data",
      "ok": "OK",
      "failed": "Falha",
      "pagination_one": "Página {{page}} de {{totalPages}} ({{count}} registro)",
      "pagination_zero": "Página {{page}} de {{totalPages}} ({{count}} registros)",
      "pagination_other": "Página {{page}} de {{totalPages}} ({{count}} registros)",
      "previous": "Anterior",
      "next": "Próxima",
      "empty": "Nenhum log encontrado para este webhook"
    }
  }
}
